import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MruDataItem } from '../mru/mru-data-item.model';

export interface CreateOneNotePageDialogModel {
    notebookItems: Array<MruDataItem>;
    onClick: () => void;
}
@Injectable({
    providedIn: 'root'
})
export class CreateOneNotePageDialogService {
    private readonly _onenotePageDialog: BehaviorSubject<CreateOneNotePageDialogModel>;

    constructor() {
        this._onenotePageDialog = new BehaviorSubject<CreateOneNotePageDialogModel>(null);
    }

    public showOneNotePageDialog(onenotePageDialog: CreateOneNotePageDialogModel) {
        this._onenotePageDialog.next(onenotePageDialog);
    }

    public get onenotePageDialog(): Observable<CreateOneNotePageDialogModel> {
        return this._onenotePageDialog.asObservable();
    }
}
